import styled from "styled-components";

export const StyledDashboardUserStatsGrid = styled.div`
   display: grid;
    grid-template-columns: repeat(auto-fit, minmax(24rem, 1fr));
    grid-column-gap: 2.5rem;
    grid-row-gap: 2.5rem;
    margin-top: 4rem;
`;

export const StyledDashboardUserStatsItem = styled.div`
    padding: 2rem 3rem 3rem 3rem;
    background: #FFFFFF;
    border: 1px solid rgba(33, 63, 125, 0.06);
    box-shadow: 3px 5px 20px rgba(0, 0, 0, 0.04);
    border-radius: 4px;

    .item-title {
        margin-top: 1.4rem;
        font-weight: 500;
        font-size: 1.4rem;
        text-transform: uppercase;
        color: ${({ theme }) => theme && theme.colors?.grey};
    }

    .item-count {
        margin-top: 1.2rem;
        font-weight: 600;
        font-size: 2.4rem;
        color: ${({ theme }) => theme && theme.colors?.darkBlue};
    }
`;
export const StyledDashboardUserStatsItemIcon = styled.div`
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    background-color: ${({ bgColor }) => bgColor && bgColor};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ color }) => color && color};
`;